import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

import Language from './Language';

const HomeHeader = ({ user, updateUser, bgColor }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Grid item xs={12} sx={{
            backgroundColor: bgColor
        }}>
            <Grid sx={{
                paddingLeft: {
                    md: 15,
                    xs: 5
                },
                paddingRight: {
                    md: 15,
                    xs: 5
                },
                paddingTop: 2,
                paddingBottom: 2,
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottomRightRadius: '16px',
                borderBottomLeftRadius: '16px',
                backgroundColor: '#fff'
            }}>
                <Tooltip title={t('header.home')} arrow>
                    <Button
                        variant={''}
                        onClick={() => {
                            navigate('/')
                        }}
                        sx={{
                            padding: 0
                        }}
                    >
                        <img
                            src={'/assets/images/mISLec-logo.png'}
                            alt={t('common.logo_alt')}
                            style={{ width: '75px', height: 'auto', maxWidth: '75px' }}
                        />
                    </Button>
                </Tooltip>

                <Stack
                    sx={{
                        alignItems: { xs: 'center', md: 'flex-end' }
                    }}
                >
                    <Language user={user} updateUser={updateUser} />
                </Stack>
            </Grid>
        </Grid>
    )
}

export default HomeHeader;